import pino from 'pino';
import browserTransmit from './browserTransmit';
import metaInformation from './metaInformation';

export { flushBeaconQueue } from './browserTransmit';

type Unit =
    | 'Seconds'
    | 'Microseconds'
    | 'Milliseconds'
    | 'Bytes'
    | 'Kilobytes'
    | 'Megabytes'
    | 'Gigabytes'
    | 'Terabytes'
    | 'Bits'
    | 'Kilobits'
    | 'Megabits'
    | 'Gigabits'
    | 'Terabits'
    | 'Percent'
    | 'Count'
    | 'Bytes/Second'
    | 'Kilobytes/Second'
    | 'Megabytes/Second'
    | 'Gigabytes/Second'
    | 'Terabytes/Second'
    | 'Bits/Second'
    | 'Kilobits/Second'
    | 'Megabits/Second'
    | 'Gigabits/Second'
    | 'Terabits/Second'
    | 'Count/Second'
    | 'None';

export type CloudWatchMetric = {
    value: number;
    unit: Unit;
    dimensions?: Record<string, string | undefined>;
};

const pinoPretty = {
    transport: {
        target: 'pino-pretty'
    }
};

const simpleLogs = {
    formatters: {
        level(level: string) {
            return { level };
        },
        bindings() {
            return {};
        },
        log() {
            return {};
        }
    },
    timestamp: false
};

const beaconTransmit = {
    browser: {
        transmit: {
            send: browserTransmit
        }
    }
};

const pinoLogger = pino({
    enabled: process.env.NEXT_PUBLIC_LOG_ENABLED !== 'false',
    level: process.env.NEXT_PUBLIC_LOG_LEVEL || 'info',
    customLevels: {
        metric: 55,
        analytic: 54
    },
    ...(process.env.NEXT_PUBLIC_LOG_BEACON_ENABLED === 'true' &&
        beaconTransmit),
    ...(process.env.PRETTY_LOGS === 'true' && pinoPretty),
    ...(process.env.SIMPLE_LOGS === 'true' && simpleLogs)
});

// TODO o11y: dynamically create these types based off of the codeowners file
type Custodians =
    | 'platform'
    | 'sell'
    | 'pnp'
    | 'home'
    | 'search'
    | 'commercial';

export type LoggerMetaData = {
    page?: string;
    component?: string;
    custodian: Custodians;
    [key: string]: string | number | undefined | Custodians;
} & ({ page: string } | { component: string });

export const setupLogger = (metaData: LoggerMetaData) => {
    const logger = pinoLogger.child(metaInformation());
    return logger.child(metaData);
};

export const serialiseError = (err: unknown) => {
    if (!err) {
        return;
    }

    const message =
        typeof err === 'object' && 'message' in err ? err.message : '';

    // its possible that err.message is not readable as its a symbol so force its addition later
    return { ...JSON.parse(JSON.stringify(err)), message };
};
